import { CheckIcon, CopyIcon } from "lucide-react";
import { type MouseEvent, useState } from "react";
import { useTranslations } from "../../i18n";
import { copyToClipboard } from "../../utils/clipboard";
import { IconButton } from "../Button/IconButton";
import { Tooltip } from "../Tooltip";
import type { ICopyIconButtonProps } from "./types";

export const CopyIconButton = (props: ICopyIconButtonProps) => {
  const { copyContent, onClick, ...iconButtonProps } = props;
  const { t } = useTranslations();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);

    const success = await copyToClipboard(copyContent);
    if (success) {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1000);
    }
  };

  return (
    <Tooltip
      content={isCopied ? t("ui.copyButton.copied") : t("ui.copyButton.copy")}
    >
      <IconButton
        {...iconButtonProps}
        aria-label={
          isCopied ? t("ui.copyButton.copied") : t("ui.copyButton.copy")
        }
        onClick={handleCopy}
      >
        {isCopied ? <CheckIcon /> : <CopyIcon />}
      </IconButton>
    </Tooltip>
  );
};
